<template>
	<div v-if="finishedLoading">
		<div class="row loans-details" :class="scoreClass" v-if="solicitacao != null">
			<div class="col-12">
				<div class="row tit_page">
					<div class="col-12">
						<div class="float-left">
							<h1>
								Meus empréstimos
								<strong>
									{{Document}}
								</strong> 
								<span>
									#{{ajustIdOportunidade(id,5)}} 
								</span>
							</h1>
						</div>

						<div class="options float-right">
							<!-- <a href="#" title="">
								<i class="printer">
								&nbsp;
								</i>
							</a>
							<a href="#" title="">
								<i class="pdf">
									&nbsp;
								</i>
							</a> -->
							<a @click="$router.go(-1)" href="javascript:;" title="Voltar">
								<i class="back">
									&nbsp;
								</i> 
								<span>
									Voltar
								</span>
							</a>
						</div>
						<div class="clearfix"></div>
					</div>
				</div>
				<hr class="divider">
				<div class="row"> 

					<!-- DETALHES POR TIPO DE EMPRESTIMO -->
					<detalhes-coletivo v-if="type == 'EMPCOL'" :id="solicitacaoId"></detalhes-coletivo>
					<detalhes-impacto v-if="type == 'EMPIMP'" :id="solicitacaoId"></detalhes-impacto>
					<detalhes-impacto v-if="type == 'EMPSOC'" :id="solicitacaoId"></detalhes-impacto>
					<detalhes-ccb v-if="type == 'EMPCCB'" :id="solicitacaoId"></detalhes-ccb>
					<!-- :::::::::: -->

					<!-- NÃO GEROU BOLEROS -->
					<aside class="col-12 col-md-4 col-lg-4" v-if="!boletos">
						<div  class="row noTickets">
							<div class="tit text-center">
								<h2>
									Aguarde os boletos serem gerados!
								</h2>
								<i class="fas fa-barcode"></i>
							</div>
						</div>
					</aside>
					<!-- ::::::::::::::::: -->					

					<!-- TABELA DE BOLETOS -->
					<aside class="col-12 col-md-4 col-lg-4" v-if="boletos">
						<div class="box-td">
							<div class="tit d-flex justify-content-between align-items-center">
								<div class="float-left">
									<h6>
										<i class="fas fa-barcode"></i>
										<span>
											Boletos
										</span>
									</h6>
								</div>
								<!-- LEGENDA STATUS DO BOLETO -->
								<div class="float-right">
									<div class="title-lg status qt">
										<span class="sts sm"></span>
										<label>Quitado</label>
									</div>
									<div class="title-lg status vc">
										<span class="sts sm"></span>
										<label>Vencido</label>
									</div>
									<div class="title-lg status av">
										<span class="sts sm"></span>
										<label>A vencer</label>
									</div>
								</div>
								<!-- :::::::::: -->
							</div>
							<div class="table-responsive">
								<table class="table">
									<thead>
										<tr>
											<th scope="col" width="38" class="align-middle">
												Parc.
											</th>
											<th scope="col" width="" class="align-middle text-center">
												Valor
											</th>
											<th scope="col" width="95" class="align-middle text-center">
												Venc.
											</th>
											<th scope="col" width="50" class="align-middle text-center">
												Boleto
											</th>
											<th scope="col" width="50" class="align-middle text-center">
												Status
											</th>
											
										</tr>
									</thead>
									<tbody>
										<tr v-for="(fatura, index) in faturas" :key="index">
											<td class="align-middle">
												{{fatura.IndiceFatura + 1}}
											</td>
											<td class="align-middle text-center">
												{{fatura.Boleto.total}}
											</td>	
											<td class="align-middle text-center">
												{{formatDate(fatura.Boleto.due_date)}}
											</td>

											<td class="align-middle text-center">
												<a v-if="fatura.HistoricoBoletos" :href="fatura.HistoricoBoletos[fatura.HistoricoBoletos.length - 1].secure_url" target="_blank">
													<i class="fas fa-barcode"></i>
												</a>
												<a v-else :href="fatura.Boleto.secure_url" target="_blank">
													<i class="fas fa-barcode"></i>
												</a>
											</td>
											
											<td class="status align-middle text-center" :class="getFaturaStatusClass(fatura)">
												<span class="sts md"></span>
											</td>
											
										</tr>
										
									</tbody>
								</table>
							</div>
							<div class="row">
								<div class="col-12">
									<router-link :to="'/emprestimos/boletos?id='+this.solicitacaoId" class="btn btn-primary btn-block all-billets" title="Visualizar todos os boletos">
										Visualizar todos os boletos
									</router-link>
								</div>
							</div>
						</div>
					</aside>
					<!-- :::::::: -->
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
   @import "../assets/styles/iouu/mixins";

    .noTickets {
		&{
			min-height: 200px;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid #ccc;
			border-radius: 5px;
			margin-right: 15px;
    		margin-left: 15px;

			@include brkp-01(1199px) {
				margin-top: 1rem;
				margin-left: 0;
				margin-right: 0;
			}
		}

		.tit {
			&{
				border: none;
				margin: 0;
				padding: 0;
			}
			h2 {
				font-weight: 700;
				text-transform: uppercase;
				font-size: calcRem(28);

				@include brkp-01(1199px) {
					font-size: calcRem(22);
				}
			}
			i {
				width: 100%;
				display: inline-block;
				padding-top: 1rem;
				font-size: calcRem(60);
			}
		}
	}

	

	.box-td {

		// MEDIA max: 1199px
		@include brkp-01(1199px) {
			margin-top: 1rem;
		}

		.table {
			td,
			th {
				// MEDIA  max: 1305px
				@include brkp-01(1300px) {
					font-size: calcRem(12) !important;
				}

				// MEDIA max: 1305px
				&:last-child {
					@include brkp-01(1305px) {
						display: none;	
					}
				}

				&:first-child {
					@include xs {
						display: none;
					}
				}

				&:nth-child(2) {
					@include xs {
						width: 80px;
					}
				}
			}
		}

		a {
			&.all-billets {
				@include xs {
					width: 100%;
					display: inline-block;
					text-align: center;
					float: none;
					font-size: 10px;
					padding-left: 0;
					padding-right: 0;
				}
			}
		}
	}

	.carousel-item {
		img {
			border-radius: 5px;
		}
	}

	.tit_page {

        .float-left {
            h1 {
                @include sm {
                    &{
                        font-size: calcRem(20);
                    }

                    span {
                        font-size: 1rem;
                    }

                    strong {
                        font-size: 1rem;
                    }
                }

                @include xs {
                    & {
                        font-size: calcRem(18);
                    }

                    span {
                        font-size: calcRem(14);
                    }

                    strong {
                        display: none;
                    }
				}
				
				// MEDIA max: 360px
				@include brkp-01(360px) {
					&{
						font-size: calcRem(15);
					}

					span {
						font-size: calcRem(12);
					}
				}

				
            }
        }

        .options {
            @include brkp-01(1000px) {
                width: 100%;
                display: inline-block;
                text-align: left;
                padding-top: 1rem;
			}
			
			@include xs {
				display: none;
			}

			@include sm {
				display: none;
			}
        }
	}

	.tit {
		.float-right {
			@include xs {
				width: 100%;
				padding-top: calcRem(12);
			}
		}
	}

	.loans-details {
		.box {
			p {
				@include xs {
					font-size: calcRem(20);
				}
			}
		}

		a {
			&.docs {

				@include brkp-01(1199px) {
					margin-top: 1rem;
				}

				@include xs {
					font-size: calcRem(18);
				}
			}
		}

		section {
			span {
				@include xs {
					font-size: calcRem(18);
				}

				&.percent {
					@include brkp-01(360px) {
						display: none;
					}
				}
			}
		}
	}
</style>

<script>
	 import ApiClient from '../utils/api-client'
	 import * as mutationTypes from '@/store/mutation-types.js'
	 import DetalhesColetivo from '@/components/loansProfiles/DetalhesColetivo'
	 import DetalhesImpacto from '@/components/loansProfiles/DetalhesImpacto'
	 import DetalhesCcb from '@/components/loansProfiles/DetalhesCcb'
	 import Masker from '@/utils/masker'

	 import FaturaTomador from '../services/api/faturaTomador';

	export default {
		data() {
			return {
				finishedLoading: false,
				faturas: null,
				solicitacao: null,
				solicitacaoId: this.$route.query.id,
				type: this.$route.query.type,
			}
		},
		components: {
			DetalhesColetivo,
			DetalhesImpacto,
			DetalhesCcb
		},
		computed: {
			id: function() {return this.ajustIdOportunidade(this.solicitacao.IdOportunidade)},
			Document: function() {return this.formatDocument(this.solicitacao.Documento)},
			scoreClass: function() {
				if(!this.solicitacao.Score ) return ""
				return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase()
			},
			boletos: function(){return this.solicitacao.GerouBoletosPagamento}
		},
		methods: {
			ajustIdOportunidade(id, qtd) {
				var s = String(id);
				while (s.length < (qtd || 2)) {
					s = "0" + s;
				}
				return s;
			},
			formatDocument(doc) {
				return Masker.maskCnpj(doc);
			},
			formatDate(date) {
				let dateArray = date.split('-')
				let day = dateArray[2]
				let month = dateArray[1]
				let year = dateArray[0]

				return day + "/" + month + "/" + year;
			},
			getFaturaStatusClass(boleto) {
				let cls;
				let stringDate = boleto.Boleto.due_date;
				let spliter    = stringDate.split("-");
				let boletoDate = new Date(spliter[0], spliter[1] - 1, spliter[2], 23, 59, 59);
				let today      = new Date();
				let status     = boleto.StatusBoleto;

				//console.log("boleto: ", boletoDate)
				//console.log("hoje: ", today)

				if(status === "" || status === undefined)  {
					// Sem status
					cls = "ds";
				} else if(boletoDate < today && status !== "paid") {
					// Vencido
					cls = "vc";
				} else if(status === "pending") {
					// A vencer
					cls = "av";
				}  else if (status === "paid"){
					// Quitado
					cls = "qt";
				} 

				return cls;
			},

			async getFaturaTomador() {

                const {data} = await FaturaTomador.GetFaturasTomador(this.solicitacaoId);

                if (data) {

                    this.faturas = data;
                }  
			},
			
			//tagueamento GA
			taggingGA() {
				this.$ga.page({
					page: '/detalhes-do-emprestimo',
					title: 'Detalhes do empréstimo',
				})
			},
		},
		async created() {

			this.$store.commit(mutationTypes.START_LOADING)

			await this.getFaturaTomador();

			ApiClient.getLoanRequest(this.solicitacaoId)
			.then(response => {
				this.solicitacao = response;

				this.finishedLoading = true
				this.$store.commit(mutationTypes.STOP_LOADING)
			})
			.catch(()=>{
				this.finishedLoading = true
				this.$store.commit(mutationTypes.STOP_LOADING)
			});

			//tagueamento GA
			await this.taggingGA();
		}
	}
</script>





// WEBPACK FOOTER //
// src/views/DetailsLoans.vue